/** Mismo criterio que reservas: inclusivo, consecutivos válidos. */
export function isDateRangeOverlapping(
  startA: string,
  endA: string,
  startB: string,
  endB: string,
): boolean {
  return startA <= endB && startB <= endA;
}

export function isValidMaintenanceRange(start: string, end: string): boolean {
  return start.length > 0 && end.length > 0 && start <= end;
}
